module.exports = __webpack_public_path__ + "static/media/incident_triangle_green.40aa80a2.svg";